import classNames from 'classnames';
import { h, JSX } from 'preact';

export interface InternalInfoProps {
    class?: string;
    text: string;
    isExpanded: boolean;
    setExpanded: (isExpanded: boolean) => void;
    closeText: string;
}

export const InternalInfo = (props: InternalInfoProps): JSX.Element => (
    <div class={classNames('relative', props.class)}>
        <div
            class='w-7 h-7 flex items-center justify-center rounded-full bg-kinola-orange text-white cursor-pointer'
            onClick={(): void => props.setExpanded(!props.isExpanded)}
        >
            <svg xmlns='http://www.w3.org/2000/svg' class='h-4 w-4' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'>
                <path stroke-linecap='round' stroke-linejoin='round' d='M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z' />
            </svg>
        </div>
        {props.isExpanded && (
            <div class='absolute top-full left-[calc(50%-9rem)] mt-2 w-72 p-6 rounded-md bg-white z-10 text-base custom-shadow-lg'>
                <div class='flex flex-col gap-2'>
                    <div>{props.text}</div>
                    <a class='absolute top-2.5 right-2.5 cursor-pointer text-neutral-400' onClick={(): void => props.setExpanded(false)}>
                        <svg xmlns='http://www.w3.org/2000/svg' class='h-5 w-5' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'>
                            <path stroke-linecap='round' stroke-linejoin='round' d='M6 18L18 6M6 6l12 12' />
                        </svg>
                    </a>
                </div>
            </div>
        )}
    </div>
);
